import { Difference } from '@mui/icons-material';
import { Tooltip, Typography } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

import ReactComponent from '@/components/ReactComponent';

import ModalRelatorioComparacaoCertidaoAcordao from './Relatorios/ModalRelatorioComparacaoCertidaoAcordao';

class ExportarRelatorioComparacaoCertidaoAcordao extends ReactComponent {
    /** @type {string} */
    cursor = 'pointer';

    /** @type {boolean} */
    openRelatorio = false;

    handleOpenRelatorio = () => {
        this.openRelatorio = true;
    };

    handleCloseRelatorio = () => {
        this.openRelatorio = false;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            render: true,
            cursor: observable,
            openRelatorio: observable,
            handleOpenRelatorio: action,
            handleCloseRelatorio: action
        });
    }

    render() {
        return (
            <>
                <Tooltip
                    title={
                        <Typography>
                            Gerar relatório de comparação de dados cadastrais e da decisão da certidão com as
                            informações do voto/acórdão
                        </Typography>
                    }
                >
                    <Difference
                        sx={{
                            mr: 1,
                            cursor: 'pointer',
                            ':hover': {
                                color: 'steelblue'
                            }
                        }}
                        onClick={this.handleOpenRelatorio}
                    />
                </Tooltip>
                {!!this.openRelatorio && (
                    <ModalRelatorioComparacaoCertidaoAcordao
                        onCloseModalImpressao={() => this.handleCloseRelatorio()}
                        openModalImpressao={true}
                    />
                )}
            </>
        );
    }
}

export default inject('stores')(observer(ExportarRelatorioComparacaoCertidaoAcordao));
